import { Fragment, h } from 'preact';
import { useLayoutEffect, useRef } from 'preact/hooks';
import DeviceBadInfo from "./DeviceBadInfo";
import { formatPrice, formatPriceWithSymbol } from "../../tools";
import MeterReadings from "./enterMeterReadings/MeterReadings";
import { useState } from 'preact/hooks';

export default function ContractInfo({ canEnterMeterReadings, enterUrl, contract, account, formParams, amounts, createOrderForContract, onChangeAmountInput, enterMeterDisabledButtonText, checkFineForContract, isFineChecked, eventNoTechipu, messages }) {

	let dateString = '';
	const useRunAfterUpdate = () => {
		const afterPaintRef = useRef(null);
		useLayoutEffect(() => {
			if (typeof afterPaintRef.current === 'function') {
				afterPaintRef.current();
				afterPaintRef.current = null;
			}
		});
		const runAfterUpdate = fn => (afterPaintRef.current = fn);
		return runAfterUpdate;
	}

	const runAfterUpdate = useRunAfterUpdate();
	let showPromisedPayment = false;
	if (contract.promisedPayment) {
		if (contract.promisedPayment.dateDue && contract.promisedPayment.paymentStatus === 'Оплачен полностью') {
			showPromisedPayment = true;
			const timestamp = Date.parse(contract.promisedPayment.dateDue);
			const dateTo = new Date(timestamp);
			const dateNow = new Date();
			const diffTime = dateTo.getTime() - dateNow.getTime();
			const diffDays = Math.ceil(diffTime / (1000 * 3600 * 24));
			if (diffDays < 0) {
				showPromisedPayment = false;
			}
			const longEnUSFormatter = new Intl.DateTimeFormat('ru-RU', {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric',
			});

			dateString = longEnUSFormatter.format(dateTo);
		}
	}

	let btnDisabledStyle = { borderColor: 'red', color: 'red' };
	let deviceMessage = { color: 'grey', display: 'inline', fontSize: '0.8em', padding: '0 15px' };
	const linkToDebt = "/accounts-details/moreinfo/" + contract.id;

	const [isVisible, setIsVisible] = useState(false);
	const handleClick = () => {
		setIsVisible(!isVisible);
	};

	return (
		<div className={"debt-table-item debt-table__item "}>
			<div className="debt-table-item-2__row">
				{
					formParams.allowedPayment && (
						<div>
							<div className="debt-table-item-2__col debt-table-item-2__col_checkbox">
								<div className="debt-table-item-2__col-title">
									<div className="text-dark debt-table-item-2__col-title-price">
										<input
											className="input debt-table-item__input"
											type="text"
											value={amounts.debt >= 0 ? formatPrice(amounts.debt) + ' ₽' : 0 + ' ₽'}
											onInput={onChangeAmountInput(contract.accountId, contract.sppsServiceDebtInfo.id, 0, undefined, 0, runAfterUpdate)}
											autoComplete="off"
										/>
									</div>
									<span className="debt-table-item__label">к оплате</span>
								</div>

								<div className="debt-table-item__print">
									{!!formParams.allowedPayment && !!contract.showPaydocUrl && (
										<button className="debt-table-item__print-btn" data-modal-url={contract.showPaydocUrl} aria-label="Распечатать платёжный документ" title="Распечатать платёжный документ">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M19 8H5C3.34 8 2 9.34 2 11V17H6V21H18V17H22V11C22 9.34 20.66 8 19 8ZM16 19H8V14H16V19ZM19 12C18.45 12 18 11.55 18 11C18 10.45 18.45 10 19 10C19.55 10 20 10.45 20 11C20 11.55 19.55 12 19 12ZM18 3H6V7H18V3Z" fill="#1A47A9" />
											</svg>
											Распечатать платежный документ
										</button>
									)}
									{!!formParams.allowedPayment && !!contract.showPayscheduleUrl && (
										<a className="debt-table-item__print-btn" href={contract.showPayscheduleUrl} target="_blank" aria-label="Распечатать график платежей" title="Распечатать график платежей">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M19 8H5C3.34 8 2 9.34 2 11V17H6V21H18V17H22V11C22 9.34 20.66 8 19 8ZM16 19H8V14H16V19ZM19 12C18.45 12 18 11.55 18 11C18 10.45 18.45 10 19 10C19.55 10 20 10.45 20 11C20 11.55 19.55 12 19 12ZM18 3H6V7H18V3Z" fill="#1A47A9" />
											</svg>
										</a>
									)}
								</div>
							</div>
							{contract.debtAmount < 0 && <div className="debt-table-item-2__col" style={{ paddingLeft: '15px', color: '#1a47a9' }}>
								<div className='debt-table-item-2__col debt-table-item-2__col_checkbox'>Переплата {-contract.debtAmount} &#8381;</div>
							</div>}
						</div>
					)
				}
				<div className="debt-table-item-2__col">
					<Fragment>
						<div className="debt-table-item-2__button-container">
							{false && (<a className="button-secondary button-secondary_border-blue" href={"/debts/details/" + contract.abonentId + '/' + contract.id + "/"}>Подробнее...</a>)}
							{
								formParams.allowedPayment && (
									<button
										className={amounts.total > 0 ? "button-primary button-primary_bgc_brand-2" : "button-primary button-primary_bgc_brand-2 disabled"}
										onClick={() => createOrderForContract(account, contract, !!canEnterMeterReadings, enterUrl)}
										disabled={isFineChecked ? amounts.total <= 0 : amounts.debt <= 0}>Оплатить {formatPriceWithSymbol(isFineChecked ? amounts.total : amounts.debt)}
									</button>
								)
							}
							{formParams.allowedPayment && contract.debtAmount > 0 && (
								<a className="button-secondary button-secondary_border-yellow" href={linkToDebt}>Откуда долг?</a>
							)}
							{!!canEnterMeterReadings && (
								<button className="button-primary button-primary_pdv_sm debt-table-item-2__counter-btn add-edit-readings-home-btn" onClick={handleClick}>
									<span className="button-primary__text">Передать/изменить показания</span>
									<span className="button-primary__icon button-primary__icon_sz_sm js__tooltip" title="Передача показаний необходима для точного расчета задолженности" />
								</button>
							)}
							{!canEnterMeterReadings && (
								<span className="button-secondary button-secondary_border button-secondary_no-device disabled" style={btnDisabledStyle}>{enterMeterDisabledButtonText}</span>
							)}
						</div>
					</Fragment>
				</div>
			</div>

			{isVisible && (
				<MeterReadings
					contract={contract}
					account={account}
					onClose={handleClick}
					enterUrl={enterUrl}
				/>
			)}
			{!canEnterMeterReadings && eventNoTechipu == 0 && (
				<div className='debt-table-item-2__row' style={deviceMessage}
					dangerouslySetInnerHTML={{ __html: '*&nbsp;' + messages.event_off }}>
				</div>
			)}
			{!canEnterMeterReadings && eventNoTechipu > 0 && (
				<div className='debt-table-item-2__row' style={deviceMessage}
					dangerouslySetInnerHTML={{ __html: '*&nbsp;' + messages.event_on }}>
				</div>
			)}

			{
				contract.promisedPayment && showPromisedPayment && (
					<Fragment>
						<div className="debt-table-item-2__row debt-table-item-2__row_additional">
							<div className="debt-table-item-2__col">
								Обещанный платеж <span className="debt-table-item__value">{formatPriceWithSymbol(amounts.debt)}</span> до <span className="debt-table-item__value">{dateString}</span>
							</div>
						</div>
						<div className="debt-table-item-2__row debt-table-item-2__row_additional">
							<div className="debt-table-item-2__col">
								Состояние с учетом обещанного платежа <span className="debt-table-item__value">{formatPriceWithSymbol(0)}</span>
							</div>
						</div>
					</Fragment>
				)
			}
			{
				amounts.fine > 0 && (
					<div className="debt-table-item-2__row">
						<div className="debt-table-item__col debt-table-item-2__col_checkbox">
							<label className="checkbox debt-table-item__checkbox">
								<input className="checkbox__input" type="checkbox" data-contract-id={contract.id} onChange={checkFineForContract(contract.id, account.id)} checked={isFineChecked} /><span className="checkbox__label debts-item-checkbox" />
								<span className="checkbox__text">пеня: {formatPriceWithSymbol(amounts.fine)}</span>
								{formParams.afterPay && (<span className="fine_pay_alert"><svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.8785 1.74256C12.3273 -0.580863 15.6727 -0.58085 17.1215 1.74258L27.4236 18.2638C28.9763 20.7537 27.2097 24 24.3021 24H3.69788C0.790281 24 -0.976235 20.7537 0.576396 18.2638L10.8785 1.74256ZM15.2306 17.7677C15.2306 18.4562 14.6797 19.0142 14 19.0142C13.3203 19.0142 12.7694 18.4562 12.7694 17.7677C12.7694 17.0793 13.3203 16.5213 14 16.5213C14.6797 16.5213 15.2306 17.0793 15.2306 17.7677ZM12.3929 9.24748L13.2835 14.6601C13.3419 15.0148 13.645 15.2748 14 15.2748C14.355 15.2748 14.6581 15.0148 14.7165 14.6601L15.6071 9.24748C15.7321 8.48773 15.1537 7.79611 14.3932 7.79611H13.6068C12.8463 7.79611 12.2679 8.48773 12.3929 9.24748Z" fill="#FC3427" /></svg><span>Вы не оплатили пени! Почему важно оплатить СЕЙЧАС&nbsp;—&nbsp;<a href="https://www.nskes.ru/svyazatsya-s-nami/zadolzhennost-sverit-raschety/24554/" target="_blank">подробнее здесь</a></span></span>)}
							</label>
						</div>
					</div>
				)
			}
			<DeviceBadInfo device={null} contract={contract} account={account} formParams={formParams} />
		</div>
	)
}
